var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center align-items-center flex-column center"},[_c('img',{attrs:{"src":"https://www.ole.com.ar/static/OLEOleV2/images/loading.gif"}}),_vm._v(" "),_c('h1',{staticClass:"text-dark text-center my-3"},[_vm._v("Cargando...")]),_vm._v(" "),_c('h1',{staticClass:"text-dark text-center my-3"},[_vm._v(_vm._s(_vm.mensaje))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02a2dc08","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/componentes/preload.vue
// module id = 233
// module chunks = 0